import React from 'react'
import { makeStyles, styled } from '@material-ui/core/styles'
import BottomNavigation from '@material-ui/core/BottomNavigation'
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction'

const useStyles = makeStyles({
  root: {
    background: '#5567a8',
    color: 'white'
  }
})

const StyledBottomNavigationAction = styled(BottomNavigationAction)(() => ({
  color: 'rgba(255, 255, 255, 0.49)',
  '&.Mui-selected': {
    color: 'white',
    fontWeight: 600
  }
}))

export interface IFormWrapperBottomNavMenus {
  label: string
  icon: React.ReactNode
  clickHandler?: () => void
  content: React.ReactNode | null
  testId?: string
  disabled?: boolean
}

interface IFormWrapperBottomNavProps {
  menus: IFormWrapperBottomNavMenus[]
  onChange: (value: any) => void
  value?: number
}

const FormWrapperBottomNav = ({
  menus,
  onChange,
  value: controlledValue
}: IFormWrapperBottomNavProps) => {
  const classes = useStyles()
  const [internalValue, setInternalValue] = React.useState(0)

  // Use controlled value if provided, otherwise use internal state
  const value = controlledValue !== undefined ? controlledValue : internalValue

  return (
    <BottomNavigation
      value={value}
      onChange={(_event, newValue) => {
        if (controlledValue === undefined) {
          setInternalValue(newValue)
        }
        onChange(newValue)
      }}
      showLabels
      className={classes.root}
    >
      {menus.map((menu, index) => (
        <StyledBottomNavigationAction
          data-testid={menu.testId ? menu.testId : menu.label}
          key={index}
          label={menu.label}
          icon={menu.icon}
          onClick={menu.clickHandler}
          disabled={menu.disabled ?? false}
        />
      ))}
    </BottomNavigation>
  )
}

export default FormWrapperBottomNav
